// Customizable Area Start
Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.cancelLabel = "Cancel"
exports.acceptLabel = "Accept"
// Customizable Area End